import React, { Component } from "react";
import { toast } from "react-toastify";
import {
  getByDmService,
  updateDmService,
  getDmService
} from "../../../services/Api";
import appConfig from "../../../config/app-config";

const { IMAGE_PATH } = appConfig;

class Information extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fotoBase64: "",
      backgroundImage: "",
      nome: "",
      sobreNome: "",
      email: "",
      cpf: "",
      user: JSON.parse(localStorage.getItem("user")) || { nivel: {} }
    };
  }

  componentWillMount = async () => {
    try {
      const { user } = this.state;
      const data = await getByDmService("/Usuario", user.id);
      this.setState({
        ...data,
        // cadastradoEm: `Cadastrado em: ${data.dataCadastro}`,
        backgroundImage: IMAGE_PATH + data.foto
      });
      const { location } = this.props;
      if (location.search.startsWith("?msg=")) {
        let last = location.search.indexOf("&");
        if (last === -1) last = undefined;
        toast.success(unescape(location.search.slice(5, last)));
      }
    } catch (e) {
      toast.error("Ocorreu um erro ao carregar os dados");
    }
  };

  handleUploadFile = files => {
    const file = files[0];
    this.setState({ nomeArquivo: file.name });
    const reader = new FileReader();
    const self = this;
    reader.onloadend = () => {
      self.setState({
        backgroundImage: reader.result,
        fotoBase64: reader.result.replace(/data:image\/(png|jpeg);base64,/g, "")
      });
    };
    reader.readAsDataURL(file);
  };

  removeFile = () => {
    this.setState({
      backgroundImage: null,
      fotoBase64: null,
      nomeArquivo: null
    });
  };

  onChangeText = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onsubmit = e => {
    e.preventDefault();
    if (e.target.checkValidity()) this.save();
  };

  save = () => {
    const { nome, sobreNome, fotoBase64, user } = this.state;
    const formData = {
      nome,
      sobreNome,
      fotoBase64
    };
    // this.setState({ isSaving: true });
    const { id } = user;
    updateDmService("/Usuario/AtualizaMeusDados", id, formData)
      .then(data => {
        // this.setState({ isSaving: false });
        localStorage.setItem("user", JSON.stringify(data));
        getDmService(`/Usuario/${id}`).then(innerData => {
          localStorage.setItem("user", JSON.stringify(innerData));
          window.location.href = `${
            window.location.pathname
          }?msg=Dados atualizados com sucesso`;
        });
      })
      .catch(err => {
        if (typeof err.error.response.data.modelState !== "undefined") {
          let error = "Ocorreu o seguinte erro: ";

          const erros = err.error.response.data.modelState;
          for (const p in erros) {
            let name = p.replace("model.", "");
            name = name[0].toUpperCase() + name.slice(1);
            error += `${name}: ${erros[p]}; `;
          }
          toast.error(error);
        } else {
          toast.error(
            "Ocorreu um erro ao salvar os dados, tente novamente mais tarde"
          );
        }
        // this.setState({ isSaving: false });
      });
  };

  render() {
    const {
      nomeArquivo,
      backgroundImage,
      nome,
      sobreNome,
      email,
      cpf
    } = this.state;
    return (
      <div className="register-edit-page">
        <form id="form" onSubmit={this.onsubmit}>
          <div className="box-padd profile-edit">
            <div className="bx--row">
              <div className="bx--col-xs-6 bx--col-md-6 v-md-margin">
                <label className="bx--label">Minha foto</label>
                <p>Arquivos jpg ou png de no máximo 500kb.</p>
              </div>
            </div>
            <div className="bx--row">
              <div className="bx--col-md-6">
                <div
                  style={{ backgroundImage: `url('${backgroundImage}')` }}
                  className="img-cadastro"
                />
                <label className="bx--btn btn-secondary-outlined v-md-margin btn-white">
                  Adicionar arquivo
                  <div className="hide">
                    <input
                      type="file"
                      onChange={e => this.handleUploadFile(e.target.files)}
                    />
                  </div>
                </label>
              </div>
            </div>
            {nomeArquivo && (
              <div className="bx--row">
                <div className="bx--col-md-6">
                  <div className="file-upload">
                    <span>{nomeArquivo}</span>
                    <svg
                      onClick={this.removeFile}
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zM4 7v2h8V7H4z" />
                    </svg>
                  </div>
                </div>
              </div>
            )}

            <div className="bx--row">
              <div className="bx--col-xs-12">
                <p className="description-option-title font-bold mg-top-20">
                  Informações
                </p>
                <p className="description-option-desc">
                  <strong>E-mail:</strong> {email} <br />
                  <strong>CPF:</strong> {cpf}
                </p>
              </div>
            </div>
            <div className="bx--row">
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label">Nome</label>
                <input
                  type="text"
                  className="bx--text-input"
                  required
                  placeholder="Nome"
                  name="nome"
                  value={nome}
                  onChange={this.onChangeText}
                />
              </div>
            </div>
            <div className="bx--row">
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label">Sobrenome</label>
                <input
                  type="text"
                  className="bx--text-input"
                  required
                  placeholder="sobreNome"
                  name="sobreNome"
                  value={sobreNome}
                  onChange={this.onChangeText}
                />
              </div>
            </div>
            <div className="mg-top-40">
              <div className="bx--row">
                <div className="bx--col-xs-2">
                  <br />
                  <button className="bx--btn btn-primary-color" type="submit">
                    Salvar Alterações
                  </button>
                </div>
                <div className="bx--col-xs-2">
                  <br />
                  <br />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default Information;



// WEBPACK FOOTER //
// ./src/screens/client/profile/Information.jsx